module.exports = {"data":{"site":{"siteMetadata":{"title":"IMBIBE - A Brand Design Firm","description":"We approach business challenges thoughtfully to deliver an extraordinary brand experience."}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 428
// module chunks = 142629428675168